import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Fade } from "react-reveal";
import DataParser from "../../../utlits/Dataparser";
import ProjectServices from "../../../Services/ProjectServices";
import TaskServices from "../../../Services/TaskServices";
import Sidebar from "../../Layouts/Sidebar";
import CreateProject from "./CreateProject";
import EditProject from "./EditProject";
import EditTask from "../Tasks/EditTask";
import CreateTask from "../Tasks/CreateTask";
import DateField from "../../Reuseable/DateField";
import AssigneField from "../../Reuseable/AssigneField";
import LeadPendingField from "../../Reuseable/LeadPendingField";
import UserProfile from "../../Reuseable/UserProfile..jsx";
import { message, Tooltip, Empty, Progress, Select, DatePicker } from "antd";
import { FaPlus, FaProjectDiagram, FaRegEdit, FaTasks, FaRegFolderOpen } from "react-icons/fa";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import UserServices from "../../../Services/UserService";
import SocketService from "../../../Services/SocketService";

const { Option } = Select;
const { RangePicker } = DatePicker;

const Projects = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [projects, setProjects] = useState([]);
    const [editProjectId, setEditProjectId] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [ownerFilter, setOwnerFilter] = useState([]);
    const [activeTimeFilter, setActiveTimeFilter] = useState(["All"]);
    const [openSections, setOpenSections] = useState({
        All: true, Planning: true, "In Progress": true, "On Hold": true, Completed: true, Abandoned: true
    });
    const [users, setUsers] = useState([]);

    const companyId = DataParser.CompanyId();
    const userPermissions = DataParser.CompanyUserPermissions();
    const companyIdentifier = DataParser.CompanyIdentifier();
    const canCreate = userPermissions.indexOf("project-create") !== -1;
    const canEdit = userPermissions.indexOf("project-edit") !== -1;
    const canDelete = userPermissions.indexOf("project-delete") !== -1;

    // Task Edit States (Synced from Tasks.jsx to provide full task editing parity)
    const [editId, setEditId] = useState(null);
    const [title, setTitle] = useState("");
    const [assignedTo, setAssignedTo] = useState(null);
    const [dueDate, setDueDate] = useState(null);
    const [periority, setPeriority] = useState("");
    const [approval, setApproval] = useState("");
    const [status, setStatus] = useState("");
    const [description, setDescription] = useState("");
    const [isRecurring, setIsRecurring] = useState(false);
    const [recurringPeriod, setRecurringPeriod] = useState("");
    const [recurringTime, setRecurringTime] = useState("09:00");
    const [recurringTotalCount, setRecurringTotalCount] = useState(0);
    const [recurringExcludeDays, setRecurringExcludeDays] = useState([]);
    const [editLoading, setEditLoading] = useState(false);
    const [isUpdatingTask, setIsUpdatingTask] = useState(false);
    const [UpdateNotesAttac, setUpdateNotesAttac] = useState(null);
    const [TaskData, setTaskData] = useState(null);
    const [TaskViewAttachment, setTaskViewAttachment] = useState(null);
    const [isUploding, setIsUploding] = useState(null);
    const [owner, setOwner] = useState(null);
    const [TaskNote, setTasKNote] = useState(null);
    const [TaskNotification, setTaskNotification] = useState(null);
    const [updatingNotes, setUpdatingNotes] = useState(false);
    const [dateLoader, setDateLoader] = useState(false);
    const latestFetchId = React.useRef(null);
    const [openedFromParentModal, setOpenedFromParentModal] = useState(false);
    const [taskNavStack, setTaskNavStack] = useState([]);
    const [selectedProjectId, setSelectedProjectId] = useState(null); // Rename to avoid conflict with 'projects' state
    const [isCreator, setIsCreator] = useState(false);
    const [taskPriority, setTaskPriority] = useState([]);
    const [taskStatus, setTaskStatus] = useState([]);
    const [createTaskInitialProjectId, setCreateTaskInitialProjectId] = useState(null);
    const [createTaskInitialProjectName, setCreateTaskInitialProjectName] = useState("");
    const [sprintId, setSprintId] = useState(null);




    const fetchProjects = () => {
        setIsLoading(true);
        ProjectServices.getAllProjects(companyId)
            .then((res) => {
                if (res.Good) {
                    setProjects(res.data.projects || []);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching projects:", err);
                setIsLoading(false);
            });
    };

    const fetchTaskDetails = (id) => {
        latestFetchId.current = String(id);
        const body = { company_id: companyId };
        TaskServices.viewTask(id, body)
            .then((res) => {
                if (latestFetchId.current !== String(id)) return;
                const data = res.data?.task;
                if (!data) { setEditLoading(false); return; }
                setTaskData(data);
                setTitle(data.title);
                setAssignedTo(data.asigned_to);
                setDueDate(data.due_date);
                setPeriority(data.priority);
                setApproval(data.approval_required);
                setStatus(data.status);
                setDescription(data.description);
                setIsRecurring(data.is_recurring || false);
                setRecurringPeriod(data.recurring_period || "");
                setRecurringTime(data.recurring_time || "09:00");
                setRecurringTotalCount(data.recurring_total_count || 0);
                setRecurringExcludeDays(Array.isArray(data.recurring_exclude_days) ? data.recurring_exclude_days : []);
                setOwner(data.created_by);

                if (data.project_id) {
                    setSelectedProjectId({ value: data.project_id, label: data.project_name || "Project " + data.project_id });
                } else {
                    setSelectedProjectId(null);
                }

                if (data.sprint_id) {
                    setSprintId({ value: data.sprint_id, label: data.sprint_name || "Sprint " + data.sprint_id, due_date: data.sprint_due_date });
                } else {
                    setSprintId(null);
                }

                setTasKNote(data.task_notes || []);
                setTaskNotification(data.task_notifications || []);
                setUpdateNotesAttac(data.task_notes_attachments || []);
                setTaskViewAttachment(data.task_attachments || []);
                setEditLoading(false);
                setIsUploding(false);
            })
            .catch((err) => {
                console.error(err);
                setEditLoading(false);
            });
    };

    const handleEditTask = (e, id, fromParent = false, skipStackUpdate = false) => {
        e.preventDefault();
        if (!skipStackUpdate) {
            if (fromParent) {
                setTaskNavStack(prev => [...prev, editId]);
            } else {
                setTaskNavStack([]);
            }
        }
        setOpenedFromParentModal(fromParent);
        setEditId(id);
        setEditLoading(true);
        setTaskData(null);
        fetchTaskDetails(id);

        // EditTask z-index (100010) is above EditProject (100008), so both can coexist.
        // Open EditTask immediately — no need to close the project first.
        setTimeout(() => {
            const editTaskEl = document.getElementById("editTaskDrawer");
            if (editTaskEl && window.bootstrap?.Offcanvas) {
                const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(editTaskEl) || new window.bootstrap.Offcanvas(editTaskEl);
                bsOffcanvas.show();
            }
        }, 0);
    };

    const handleEditTaskCloseFromProject = () => {
        if (openedFromParentModal && TaskData && TaskData.parent_id && String(TaskData.parent_id) !== "0") {
            const newStack = taskNavStack.slice(0, -1);
            setTaskNavStack(newStack);
            const fromParent = newStack.length > 0;
            handleEditTask({ preventDefault: () => {} }, TaskData.parent_id, fromParent, true);
            return;
        }
        // No parent in chain — hide EditTask and reopen the project modal
        const editTaskEl = document.getElementById("editTaskDrawer");
        if (editTaskEl && window.bootstrap?.Offcanvas) {
            const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(editTaskEl);
            if (bsOffcanvas) bsOffcanvas.hide();
        }
        // EditProject is a portal-based modal — it opens/closes via React state only
    };

    const handelDeleteNote = (e, ids) => {
        e.preventDefault();
        const data = {
            company_id: companyId,
            company_identifier: companyIdentifier,
        };
        TaskServices.deleteTaskNote(ids, data).then((res) => {
            fetchTaskDetails(editId);
            setUpdatingNotes(!updatingNotes);
        });
    };

    const TaskNotesAttachmentImages = (id) => fetchTaskDetails(id);
    const TaskAttachmentImages = (id) => fetchTaskDetails(id);

    const handleSubmitTask = (e, id) => {
        e.preventDefault();
        if (isRecurring && !recurringPeriod) {
            message.error("Please select a recurrence period for recurring tasks!");
            return;
        }
        setDateLoader(true);
        setIsUpdatingTask(true);

        // ✅ Date Validation: Task <= Sprint <= Project
        const selectedDate = moment(dueDate).startOf('day');
        const today = moment().startOf('day');

        if (selectedDate.isBefore(today)) {
            message.warning("Due date cannot be in the past");
            setDateLoader(false);
            setIsUpdatingTask(false);
            return;
        }

        if (sprintId?.due_date) {
            const sprintEnd = moment(sprintId.due_date).endOf('day');
            if (selectedDate.isAfter(sprintEnd)) {
                message.warning(`Task due date cannot exceed Sprint due date (${moment(sprintId.due_date).format("DD-MM-YYYY")})`);
                setDateLoader(false);
                setIsUpdatingTask(false);
                return;
            }
        } else if (selectedProjectId?.value) {
            const project = projects.find(p => String(p.id || p._id) === String(selectedProjectId.value));
            if (project?.due_date) {
                const projectEnd = moment(project.due_date).endOf('day');
                if (selectedDate.isAfter(projectEnd)) {
                    message.warning(`Task due date cannot exceed Project due date (${moment(project.due_date).format("DD-MM-YYYY")})`);
                    setDateLoader(false);
                    setIsUpdatingTask(false);
                    return;
                }
            }
        }

        const newDate = moment(dueDate).format("YYYY-MM-DD");
        const body = {
            company_id: companyId,
            company_identifier: companyIdentifier,
            title: title,
            assign_to: assignedTo,
            due_date: newDate,
            priority: periority,
            approval_required: approval,
            status: status,
            description: description,
            is_recurring: isRecurring,
            recurring_period: recurringPeriod,
            recurring_time: recurringTime,
            recurring_total_count: recurringTotalCount,
            recurring_exclude_days: recurringExcludeDays,
            project_id: selectedProjectId ? selectedProjectId.value : 0,
            sprint_id: sprintId ? sprintId.value : null,
        };
        TaskServices.updateTask(id, body)
            .then((res) => {
                setDateLoader(false);
                setIsUpdatingTask(false);
                document.getElementById("CloseTaskEdit")?.click();
                fetchProjects(); // Refresh everything to show changes
                message.success("Task updated successfully!");
            })
            .catch((err) => {
                console.error("Error updating task:", err);
                setDateLoader(false);
                setIsUpdatingTask(false);
            });
    };

    useEffect(() => {
        fetchProjects();
        const fetchUsers = () => {
            UserServices.getProjectUsers(companyId)
                .then((res) => {
                    if (res.Good) {
                        setUsers(res.data.user || []);
                    }
                })
                .catch((err) => console.error("Error fetching users:", err));
        };

        const fetchTaskMetadata = () => {
            TaskServices.getAllTask(companyId, { skipTasks: true }).then((res) => {
                if (res.Good || res.data) {
                    setTaskStatus(res.data.status || []);
                    setTaskPriority(res.data.priority || []);
                }
            }).catch(err => console.error("Error fetching task metadata:", err));
        };

        fetchUsers();
        fetchTaskMetadata();

        // 🟢 Socket Integration for Real-time Updates
        SocketService.connect();

        const handleProjectUpdate = (data) => {
            if (String(data.company_id) === String(companyId)) {
                console.log("🔔 Project/Sprint update received via Socket:", data.action);
                fetchProjects();
            }
        };

        const handleTaskNotification = (data) => {
            if (String(data.company_id) === String(companyId)) {
                console.log("🔔 Task notification received via Socket, refreshing project view...");
                fetchProjects();
            }
        };

        SocketService.on("project_update", handleProjectUpdate);
        SocketService.on("notification", handleTaskNotification);

        return () => {
            SocketService.off("project_update", handleProjectUpdate);
            SocketService.off("notification", handleTaskNotification);
        };
    }, [companyId]);

    useEffect(() => {
        const projectId = location?.state?.openProjectId;
        if (!projectId) return;
        setEditProjectId(projectId);
    }, [location?.state?.openProjectId]);

    const handleOpenCreateTaskFromProject = (projectId, projectName) => {
        setCreateTaskInitialProjectId(projectId);
        setCreateTaskInitialProjectName(projectName);
        // Trigger the hidden button
        setTimeout(() => {
            document.getElementById("triggerCreateTaskFromProject")?.click();
        }, 100);
    };


    const getStatusCounts = () => {
        const counts = {
            All: projects.length,
            Planning: 0,
            "In Progress": 0,
            "On Hold": 0,
            Completed: 0,
            Abandoned: 0
        };
        projects.forEach(p => {
            if (counts[p.status] !== undefined) counts[p.status]++;
        });
        return counts;
    };

    const statusCounts = getStatusCounts();

    const getFilteredProjects = (statusKey) => {
        return projects.filter(project => {
            const matchesSearch = project.name.toLowerCase().includes(searchValue.toLowerCase());
            const matchesStatus = statusKey === "All" || project.status === statusKey;
            const matchesOwner = ownerFilter.length === 0 || ownerFilter.includes(project.owner);
            return matchesSearch && matchesStatus && matchesOwner;
        });
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "Planning": return "#3498db";
            case "In Progress": return "#f39c12";
            case "On Hold": return "#e74c3c";
            case "Completed": return "#27ae60";
            case "Abandoned": return "#95a5a6";
            default: return "#34495e";
        }
    };

    return (
        <>
            <Helmet title="Projects | Planit" />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid px-4 pb-4 pt-0">
                        <style>{`
                            .task-filters-row { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin-bottom: 12px; border-top: 1px solid #F2F2F2; border-bottom: 1px solid #F2F2F2; padding: 10px 0; }
                            .task-filters-row .custom-filter.float-select-wrap .ant-select-selector,
                            .task-filters-row .custom-filter.float-select-wrap .ant-picker {
                                height: 34px !important; min-height: 34px !important; border-radius: 6px !important;
                                border: 1.5px solid #F2F2F2 !important;
                            }
                            .task-filters-row .custom-filter.float-select-wrap .ant-picker-separator,
                            .task-filters-row .custom-filter.float-select-wrap .ant-picker-range-separator {
                                color: #D2D2D2 !important;
                            }
                            .task-filters-row .custom-filter.float-select-wrap .ant-select:hover .ant-select-selector,
                            .task-filters-row .custom-filter.float-select-wrap .ant-select-focused .ant-select-selector { border-color: #1D1D1D !important; box-shadow: none !important; }
                            .task-filters-row .custom-filter.float-select-wrap .ant-picker:hover,
                            .task-filters-row .custom-filter.float-select-wrap .ant-picker-focused { border-color: #1D1D1D !important; box-shadow: none !important; }
                            .task-filters-row .custom-filter.float-select-wrap .ant-select-clear { display: none !important; }
                            .task-filters-row .custom-filter.float-select-wrap .ant-select-selection-item,
                            .task-filters-row .custom-filter.float-select-wrap .ant-select-selection-placeholder,
                            .task-filters-row .custom-filter.float-select-wrap .ant-picker-input > input {
                                line-height: 30px !important; font-size: 11px !important; font-weight: 300 !important;
                            }
                            .task-filters-row .custom-filter.float-select-wrap .ant-select-selector {
                                display: flex !important; align-items: center !important;
                            }
                            .task-filters-row .custom-filter.float-select-wrap .ant-select-selection-overflow {
                                display: flex !important; align-items: center !important;
                                flex-wrap: nowrap !important; height: 100% !important; overflow: hidden !important;
                            }
                            .task-filters-row .custom-filter.float-select-wrap label {
                                position: absolute; left: 10px; top: 50%; transform: translateY(-50%);
                                font-size: 11px !important; font-weight: 300 !important; color: #D2D2D2; background: transparent;
                                padding: 0 4px; z-index: 10; transition: all 0.2s ease;
                                pointer-events: none;
                            }
                            .task-filters-row .custom-filter.float-select-wrap.has-value label,
                            .task-filters-row .custom-filter.float-select-wrap:focus-within label { 
                                top: 0; transform: translateY(-50%); font-size: 11px !important; 
                                font-weight: 600 !important; color: #1d1d1d; background: #fff; 
                            }
                            .task-search-wrap { position: relative; width: 180px; flex-shrink: 0; }
                            .task-search-wrap input {
                                width: 100%; height: 34px; padding: 0 36px 0 14px;
                                border: 1.5px solid #F2F2F2; border-radius: 6px;
                                font-size: 11px !important; font-weight: 300 !important; outline: none; background: #fff;
                            }
                            .task-search-wrap input:focus { border-color: #1D1D1D !important; box-shadow: none !important; }
                            .task-search-wrap label {
                                position: absolute; left: 14px; top: 50%; transform: translateY(-50%);
                                font-size: 11px !important; font-weight: 300 !important; color: #D2D2D2; pointer-events: none;
                                transition: all 0.2s ease; background: #fff; padding: 0 2px;
                            }
                            .task-search-wrap input:focus ~ label,
                            .task-search-wrap input:not(:placeholder-shown) ~ label {
                                top: 0; font-size: 11px !important; font-weight: 600 !important; color: #1D1D1D;
                            }
                            .task-create-btn {
                                height: 34px; border-radius: 6px; font-size: 13px; font-weight: 700;
                                padding: 0 12px; display: flex; align-items: center; gap: 6px;
                                background-color: #0DDFAB; border: 1px solid #0DDFAB; color: #fff;
                                white-space: nowrap; cursor: pointer; text-decoration: none; flex-shrink: 0;
                                transition: all 0.2s;
                            }
                            .task-create-btn:hover { background-color: #0bc698; border-color: #0bc698; color: #fff; transform: translateY(-1px); }
                            
                            .project-stat-chip {
                                flex: 1 1 0;
                                min-width: 0;
                                height: 62px;
                                background: #fff;
                                border: 1px solid #F2F2F2;
                                border-radius: 8px;
                                padding: 8px 10px;
                                cursor: pointer;
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;
                                justify-content: space-between;
                                box-shadow: 0 1px 2px rgba(0,0,0,0.02);
                                transition: border-color 0.15s;
                                user-select: none;
                            }
                            .project-stat-chip:hover { border-color: #0DDFAB; }
                            .project-stat-chip.active { border-color: #0DDFAB; background: #fff; }
                            .project-stat-chip .icon-box {
                                width: 24px; height: 24px; border-radius: 4px;
                                background: #e6f9f4; display: flex; align-items: center;
                                justify-content: center; flex-shrink: 0; margin-bottom: 4px;
                            }
                            .project-stat-chip .icon-box i { font-size: 13px; color: #0DDFAB; line-height: 1; }
                            
                            .subtask-badge:hover {
                                background: #1d1d1d !important;
                                color: #ffffff !important;
                            }
                            .task-row:hover { background-color: #f9fafb !important; }
                        `}</style>

                        {/* ── Stats Filter Bar ─────────────────────────────── */}
                        <div style={{ display: 'flex', gap: '10px', marginBottom: '14px', flexWrap: 'nowrap', overflowX: 'auto', paddingBottom: '4px' }}>
                            {[
                                { key: 'All', label: 'All Projects', icon: 'uil-folder' },
                                { key: 'Planning', label: 'Planning', icon: 'uil-clipboard-notes' },
                                { key: 'In Progress', label: 'In Progress', icon: 'uil-sync' },
                                { key: 'On Hold', label: 'On Hold', icon: 'uil-pause-circle' },
                                { key: 'Completed', label: 'Completed', icon: 'uil-check-circle' },
                                { key: 'Abandoned', label: 'Abandoned', icon: 'uil-times-circle' }
                            ].map(filter => {
                                const isActive = activeTimeFilter.includes(filter.key);
                                return (
                                    <div
                                        key={filter.key}
                                        className={`project-stat-chip ${isActive ? 'active' : ''}`}
                                        onClick={() => setActiveTimeFilter([filter.key])}
                                    >
                                        <div className="icon-box">
                                            <i className={filter.icon} />
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', width: '100%', gap: '4px' }}>
                                            <span style={{ fontSize: '12px', color: '#1D1D1D', fontWeight: '400', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0 }}>
                                                {filter.label}
                                            </span>
                                            <span style={{ fontSize: '16px', fontWeight: '700', color: '#1a2332', lineHeight: 1, flexShrink: 0 }}>
                                                {String(statusCounts[filter.key] || 0).padStart(2, '0')}
                                            </span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* ── Search + Filters + Create Button ───────────────── */}
                        <div className="task-filters-row">
                            {/* Search */}
                            <div className="task-search-wrap">
                                <input type="text" placeholder=" " value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
                                <label>Search Projects</label>
                                {searchValue
                                    ? <i className="uil-times" onMouseDown={(e) => { e.preventDefault(); setSearchValue(''); }} style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: '#aaa', fontSize: '15px', cursor: 'pointer', zIndex: 20 }} />
                                    : <i className="uil-search" style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: '#aaa', fontSize: '15px', pointerEvents: 'none', zIndex: 20 }} />
                                }
                            </div>

                            {/* Owner Filter */}
                            <div className={`float-select-wrap custom-filter ${ownerFilter?.length > 0 ? 'has-value' : ''}`} style={{ width: '160px', flexShrink: 0, position: 'relative' }}>
                                <label>Owner</label>
                                <Select mode="multiple" value={ownerFilter} onChange={setOwnerFilter} allowClear placeholder="" maxTagCount={ownerFilter?.length > 1 ? 0 : 1} maxTagPlaceholder={(v) => <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>{v.length} Selected <span onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); setOwnerFilter([]); }} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}><i className="uil-times" style={{ fontSize: '13px', color: '#999' }} /></span></div>} showSearch style={{ width: '100%' }}>
                                    {users.map(u => <Option key={u.id} value={u.id}>{u.full_name}</Option>)}
                                </Select>
                            </div>

                            {/* Date Range */}
                            <div className="float-select-wrap custom-filter" style={{ width: '215px', flexShrink: 0, position: 'relative' }}>
                                <RangePicker
                                    separator="→"
                                    placeholder={['Start Date', 'End Date']}
                                    style={{ width: '100%' }}
                                    suffixIcon={
                                        <div style={{ backgroundColor: '#F4F4F4', borderRadius: '5px', width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '-4px' }}>
                                            <i className="uil-schedule" style={{ color: '#A0A0A0', fontSize: '14px' }} />
                                        </div>
                                    }
                                />
                            </div>

                            {/* Create Button */}
                            {canCreate && (
                                <div style={{ marginLeft: 'auto' }}>
                                    <button
                                        className="task-create-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target="#createProjectDrawer"
                                    >
                                        <i className="uil-plus" style={{ fontSize: '15px' }} /> Create Project
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* ── Project Listing Table ────────────────────────── */}
                        {(() => {
                            const COL = { created: '140px', status: '150px', owner: '150px', date: '120px' };
                            const headSt = { fontSize: '13px', fontWeight: '600', color: '#212529', textAlign: 'left', display: 'block' };

                            return (
                                <div style={{ background: '#fff', marginTop: '10px' }}>
                                    {/* Table Body */}
                                    {isLoading ? (
                                        Array(5).fill(0).map((_, i) => (
                                            <div key={i} style={{ display: 'flex', alignItems: 'center', minHeight: '44px', borderBottom: '1px solid #f5f5f5', padding: '4px 0' }}>
                                                <div style={{ flex: 1, paddingLeft: '16px' }}><Skeleton width="60%" height={16} /></div>
                                                <div style={{ width: COL.created, padding: '0 8px' }}><Skeleton width="80%" height={16} /></div>
                                                <div style={{ width: COL.status, padding: '0 8px' }}><Skeleton width="80%" height={16} /></div>
                                                <div style={{ width: COL.owner, padding: '0 8px' }}><Skeleton width="80%" height={16} /></div>
                                                <div style={{ width: COL.date, padding: '0 8px' }}><Skeleton width="80%" height={16} /></div>
                                            </div>
                                        ))
                                    ) : (
                                        (() => {
                                            const CHIP_LABELS = {
                                                All: 'All Projects', Planning: 'Planning Projects', 'In Progress': 'In Progress Projects',
                                                'On Hold': 'On Hold Projects', Completed: 'Completed Projects', Abandoned: 'Abandoned Projects'
                                            };
                                            const multiMode = activeTimeFilter.length > 1;

                                            return activeTimeFilter.map((statusKey, idx) => {
                                                const filteredProjects = getFilteredProjects(statusKey);
                                                const label = CHIP_LABELS[statusKey] || statusKey;
                                                const isOpen = !multiMode || openSections[statusKey] !== false;

                                                return (
                                                    <div key={statusKey} style={{ marginBottom: idx < activeTimeFilter.length - 1 ? '20px' : '0' }}>
                                                        <div
                                                            style={{
                                                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                                padding: '8px 4px', borderBottom: '1px solid #eaecf0',
                                                                userSelect: 'none'
                                                            }}
                                                        >
                                                            <span style={{ fontSize: '14px', fontWeight: '700', color: '#1a2332' }}>{label}</span>
                                                            {multiMode && (
                                                                <div
                                                                    onClick={() => setOpenSections(prev => ({ ...prev, [statusKey]: !isOpen }))}
                                                                    style={{
                                                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                        width: '22px', height: '22px', borderRadius: '6px',
                                                                        border: '1px solid #ECECEC', background: 'transparent',
                                                                        color: '#8E8E8E', cursor: 'pointer', flexShrink: 0,
                                                                        transition: 'all 0.2s ease',
                                                                    }}
                                                                    onMouseEnter={e => { e.currentTarget.style.borderColor = '#adb5bd'; e.currentTarget.style.color = '#1D1D1D'; }}
                                                                    onMouseLeave={e => { e.currentTarget.style.borderColor = '#ECECEC'; e.currentTarget.style.color = '#8E8E8E'; }}
                                                                >
                                                                    <i className={isOpen ? 'uil-angle-up' : 'uil-angle-down'} style={{ fontSize: '12px', lineHeight: 1 }} />
                                                                </div>
                                                            )}
                                                        </div>
                                                        {isOpen && (
                                                            <>
                                                                {/* Table Header */}
                                                                <div style={{ display: 'flex', alignItems: 'center', padding: '8px 0', background: '#F2F2F2' }}>
                                                                    <div style={{ flex: 1, minWidth: 0, paddingLeft: '16px' }}><span style={headSt}>Project Title</span></div>
                                                                    <div style={{ width: COL.created, flexShrink: 0, padding: '0 8px' }}><span style={headSt}>Created By</span></div>
                                                                    <div style={{ width: COL.status, flexShrink: 0, padding: '0 8px' }}><span style={headSt}>Status</span></div>
                                                                    <div style={{ width: COL.owner, flexShrink: 0, padding: '0 8px' }}><span style={headSt}>Owner</span></div>
                                                                    <div style={{ width: COL.date, flexShrink: 0, padding: '0 8px' }}><span style={headSt}>Due Date</span></div>
                                                                </div>

                                                                <Fade big>
                                                                    <div>
                                                                        {filteredProjects.length === 0 ? (
                                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '30px 20px', color: '#9ca3af' }}>
                                                                                <i className="uil-clipboard-alt" style={{ fontSize: '32px', marginBottom: '6px' }} />
                                                                                <span style={{ fontSize: '13px' }}>No projects found.</span>
                                                                            </div>
                                                                        ) : (
                                                                            filteredProjects.map(project => {
                                                                                const currentUserId = String(DataParser.UserId() || "");
                                                                                const canEditProject = canEdit || String(project.created_by) === currentUserId || String(project.owner) === currentUserId;

                                                                                return (
                                                                                    <div key={project.id} style={{ borderBottom: '1px solid #f5f5f5' }}>
                                                                                        <div className="task-row" style={{ display: 'flex', alignItems: 'center', minHeight: '44px', padding: '4px 0' }}>
                                                                                            <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: '8px', paddingLeft: '12px', paddingRight: '8px', overflow: 'hidden' }}>
                                                                                                <div role={canEditProject ? "button" : ""} onClick={() => canEditProject && setEditProjectId(project.id)} className="d-flex align-items-center h-100 cursor-pointer" style={{ overflow: 'hidden', flex: 1, minWidth: 0 }}>
                                                                                                    <FaRegFolderOpen className="me-2" style={{ color: getStatusColor(project.status), fontSize: '15px', flexShrink: 0 }} />
                                                                                                    <span className="m-0 fw-medium text-truncate" style={{ color: "#111827", fontSize: '13px' }}>{project.name}</span>
                                                                                                    <style>
                                                                                                        {`
                                                                                                        .project-task-count-badge {
                                                                                                            background: #F2F2F2; 
                                                                                                            color: #1d1d1d; 
                                                                                                            padding: 2px 8px; 
                                                                                                            border-radius: 6px; 
                                                                                                            font-size: 11px; 
                                                                                                            font-weight: 700;
                                                                                                            display: inline-flex;
                                                                                                            align-items: center;
                                                                                                            gap: 4px;
                                                                                                            margin-left: 8px;
                                                                                                            transition: all 0.2s ease;
                                                                                                            cursor: pointer;
                                                                                                            flex-shrink: 0;
                                                                                                        }
                                                                                                        .project-task-count-badge:hover {
                                                                                                            background: #1d1d1d !important;
                                                                                                            color: #ffffff !important;
                                                                                                        }
                                                                                                    `}
                                                                                                    </style>
                                                                                                    {project.tasks && project.tasks.length > 0 && (
                                                                                                        <Tooltip title={`${project.tasks.length} Tasks linked`}>
                                                                                                            <span className="project-task-count-badge">
                                                                                                                <FaProjectDiagram style={{ fontSize: '11px' }} />
                                                                                                                +{project.tasks.length}
                                                                                                            </span>
                                                                                                        </Tooltip>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>

                                                                                            <div style={{ width: COL.created, flexShrink: 0, padding: '0 8px', display: 'flex', alignItems: 'center', gap: '6px', overflow: 'hidden' }}>
                                                                                                {(() => {
                                                                                                    const user = project.created_by_user;
                                                                                                    const fullName = `${user?.first_name || ""} ${user?.last_name || ""}`.trim() || "System";
                                                                                                    return (
                                                                                                        <>
                                                                                                            <UserProfile username={fullName} userImage={user?.image} style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                                                                                                            <span className="text-truncate" style={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500' }}>{fullName}</span>
                                                                                                        </>
                                                                                                    );
                                                                                                })()}
                                                                                            </div>

                                                                                            <div style={{ width: COL.status, flexShrink: 0, padding: '0 8px' }}>
                                                                                                {canEditProject ? (
                                                                                                    <LeadPendingField item={project} Status={['Planning', 'In Progress', 'On Hold', 'Completed', 'Abandoned']} DefaultStatus={project.status} Services={ProjectServices.updateProject} data={(e) => setProjects(prev => prev.map(p => p.id === project.id ? { ...p, status: e.target.value } : p))} fontSize="13px" />
                                                                                                ) : (
                                                                                                    <span className="text-truncate" style={{ color: getStatusColor(project.status), fontWeight: '600', fontSize: '13px' }}>{project.status}</span>
                                                                                                )}
                                                                                            </div>

                                                                                            <div style={{ width: COL.owner, flexShrink: 0, padding: '0 8px' }}>
                                                                                                {canEditProject ? (
                                                                                                    <AssigneField item={project} assigne={users} Services={(id, d) => ProjectServices.updateProject(id, { owner: d.owner || d.assignee || d.asigned_to })} Owner={project.project_owner} localUpdate={(id, d) => {
                                                                                                        const userId = d.owner || d.assignee || d.asigned_to;
                                                                                                        setProjects(prev => prev.map(p => Number(p.id) === Number(id) ? { ...p, owner: userId, project_owner: users.find(u => Number(u.id) === Number(userId)) } : p));
                                                                                                    }} avatarSize="24px" textColor="#1d1d1d" styles={{ fontSize: '13px' }} />
                                                                                                ) : (
                                                                                                    <div style={{ display: "flex", alignItems: "center", gap: "6px", width: "100%", overflow: 'hidden' }}>
                                                                                                        {(() => {
                                                                                                            const user = project.project_owner;
                                                                                                            const fullName = `${user?.first_name || ""} ${user?.last_name || ""}`.trim() || "System";
                                                                                                            return (
                                                                                                                <>
                                                                                                                    <UserProfile username={fullName} userImage={user?.image} style={{ width: '24px', height: '24px', flexShrink: 0 }} />
                                                                                                                    <span className="text-truncate" style={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500' }}>{fullName}</span>
                                                                                                                </>
                                                                                                            );
                                                                                                        })()}
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>

                                                                                            <div style={{ width: COL.date, flexShrink: 0, padding: '0 8px' }}>
                                                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                                                    <i className="uil-calendar-alt" style={{ fontSize: '20px', color: '#0DDFAB', flexShrink: 0 }} />
                                                                                                    {canEditProject ? (
                                                                                                        <DateField
                                                                                                            item={project}
                                                                                                            defaultDate={project.due_date}
                                                                                                            Services={(id, d) => ProjectServices.updateProject(id, { due_date: d.duedate ? (typeof d.duedate.format === 'function' ? d.duedate.format("YYYY-MM-DD") : d.duedate) : d.due_date })}
                                                                                                            data={(nd) => setProjects(prev => prev.map(p => p.id === project.id ? { ...p, due_date: nd } : p))}
                                                                                                            styles={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500' }}
                                                                                                            suffixIcon={null}
                                                                                                            format="D, MMMM"
                                                                                                        />
                                                                                                    ) : (
                                                                                                        <span style={{ fontSize: '13px', color: '#1d1d1d', fontWeight: '500', whiteSpace: 'nowrap' }}>
                                                                                                            {project.due_date ? moment(project.due_date).format('D, MMMM') : 'Select date'}
                                                                                                        </span>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            })
                                                                        )}
                                                                    </div>
                                                                </Fade>
                                                            </>
                                                        )}
                                                    </div>
                                                );
                                            });
                                        })()
                                    )}
                                </div>
                            );
                        })()}

                        {/* Drawers */}
                        <CreateProject id="createProjectDrawer" reFreshData={fetchProjects} />
                        {editProjectId && (
                            <EditProject
                                id="editProjectDrawer"
                                projectId={editProjectId}
                                reFreshData={fetchProjects}
                                onCreateTask={(pid, pname) => handleOpenCreateTaskFromProject(pid, pname)}
                                onEditTask={(tid) => handleEditTask({ preventDefault: () => { } }, tid)}
                                onClose={() => setEditProjectId(null)}
                            />
                        )}

                        <EditTask
                            mid="editTaskDrawer"
                            EditId={editId}
                            title={title}
                            assignedTo={assignedTo}
                            dueDate={dueDate}
                            periority={periority}
                            approval={approval}
                            status={status}
                            description={description}
                            setTitle={setTitle}
                            setAssignedTo={setAssignedTo}
                            setDueDate={setDueDate}
                            setPeriority={setPeriority}
                            setApproval={setApproval}
                            setStatus={setStatus}
                            setDescription={setDescription}
                            userPermissions={userPermissions}
                            reFreshData={fetchProjects}
                            TaskData={TaskData}
                            taskOwner={users}
                            statuses={taskStatus}
                            priority={taskPriority}
                            owner={owner}
                            setOwner={setOwner}
                            TaskNotification={TaskNotification}
                            TaskNote={TaskNote}
                            setUpdatingNotes={setUpdatingNotes}
                            updatingNotes={updatingNotes}
                            TaskNotes={(id) => fetchTaskDetails(id)}
                            handelDeleteNote={(e, ids) => handelDeleteNote(e, ids)}
                            handleSubmit={handleSubmitTask}
                            UpdateNotesAttac={UpdateNotesAttac}
                            setUpdateNotesAttac={setUpdateNotesAttac}
                            TaskNotesAttachmentImages={TaskNotesAttachmentImages}
                            isUploding={isUploding}
                            setIsUploding={setIsUploding}
                            TaskAttachmentImages={TaskAttachmentImages}
                            TaskViewAttachment={TaskViewAttachment}
                            setTaskViewAttachment={setTaskViewAttachment}
                            TaskNotifications={(id) => fetchTaskDetails(id)}
                            fetchTaskDetails={fetchTaskDetails}
                            editLoading={editLoading}
                            setEditLoading={setEditLoading}
                            recurringTime={recurringTime}
                            setRecurringTime={setRecurringTime}
                            recurringTotalCount={recurringTotalCount}
                            setRecurringTotalCount={setRecurringTotalCount}
                            isUpdatingTask={isUpdatingTask}
                            isRecurring={isRecurring}
                            setIsRecurring={setIsRecurring}
                            recurringPeriod={recurringPeriod}
                            setRecurringPeriod={setRecurringPeriod}
                            allTasks={[]} // Flat display in projects doesn't strictly need the full hierarchy for the drawer
                            recurringExcludeDays={recurringExcludeDays}
                            setRecurringExcludeDays={setRecurringExcludeDays}
                            projects={projects}
                            projectId={selectedProjectId}
                            setProjectId={setSelectedProjectId}
                            sprintId={sprintId}
                            setSprintId={setSprintId}
                            handelDrawer={(e, id) => handleEditTask({ preventDefault: () => {} }, id, true)}
                            openedFromParentModal={openedFromParentModal}
                            onCloseDrawer={handleEditTaskCloseFromProject}
                        />

                        {/* Quick Create Task Trigger */}
                        <div id="triggerCreateTaskFromProject" style={{ display: 'none' }} data-bs-toggle="modal" data-bs-target="#createTaskFromProjectCanvas"></div>
                        <CreateTask
                            key={`create-task-project-${createTaskInitialProjectId || 'general'}`}
                            id="createTaskFromProjectCanvas"
                            labelledby="createTaskFromProjectLabel"
                            priority={taskPriority}
                            statuses={taskStatus}
                            taskOwner={users}
                            reFreshData={fetchProjects}
                            initialProjectId={createTaskInitialProjectId}
                            initialProjectName={createTaskInitialProjectName}
                            projects={projects}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Projects;
